import { Menu, Button, useMantineColorScheme, Text, Stack } from "@mantine/core"
import { Icon } from "@iconify/react"
import { Icons } from "src/components/ui/Icons"
import { signOut } from "supertokens-website"
import { useAppState } from "src/state"
import { User_Roles_Enum } from "src/state/gql/_types"
import app from "../../../../package.json"
import { Link } from "react-router-dom"

async function onLogout() {
    await signOut()
    window.location.href = "/"
}

const ProfileMenu = () => {

    const { colorScheme, toggleColorScheme } = useMantineColorScheme()
    const userProfile = useAppState(state => state.profile)
    const { user_role } = useAppState(state => state.auth)

    if (!userProfile) return null

    return (
        <Menu
            withArrow
            width={150}
        >

            <Menu.Target>
                <Button
                    px={7}
                    variant="subtle"
                    color="dark"
                    rightSection={<Icon icon={Icons.user} width={30} color='var(--mantine-color-black)'/>}
                    justify="space-between"
                    className="profile-button"
                >
                    <Stack gap={1} align="flex-start" visibleFrom="sm">
                        {userProfile?.first_name} {userProfile?.last_name}
                        <Text component="span" size="12px" c="dimmed">{userProfile?.user_type?.display}</Text>
                    </Stack>
                    
                </Button>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Item
                    leftSection={<Icon icon={Icons.user} width={16}/>}
                    component={Link}
                    to="/profile"
                >
                    My Profile
                </Menu.Item>
                {user_role === User_Roles_Enum.AgencyOperationsAdministrator && (
                    <Menu.Item
                        leftSection={<Icon icon={Icons.guideline} width={16}/>}
                        component={Link}
                        to="/guidelines"
                    >
                        Guidelines
                    </Menu.Item>
                )}
                <Menu.Item
                    leftSection={<Icon icon={colorScheme === 'light' ? Icons.dark : Icons.light} width={16}/>}
                    onClick={() => toggleColorScheme()}
                >
                    {colorScheme === 'light' ? 'Dark' : 'Light'} Mode
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item leftSection={<Icon icon={Icons.out} width={16}/>} onClick={onLogout}>Sign Out</Menu.Item>
                <Menu.Divider />
                <Menu.Label>Version: {app.version}</Menu.Label>
            </Menu.Dropdown>  

        </Menu> 
    )
}

export default ProfileMenu